<template>
	<div>
		<v-container grid-list-lg class="my-raports-container" v-if="showcards">
			<v-layout row wrap>
				<MyRaportCard v-for="status in statuses" :key="status.id" :status_info="status" />
			</v-layout>
		</v-container>
		<router-view></router-view>
	</div>
</template>

<script>
import MyRaportCard from "@/components/cards/MyRaportCard.vue";
import reports from "@/config/api/api_events/reports.js";
import native_capacitor from "@/config/js_helper/native_capacitor";

export default {
	name: "MyRaports",
	props: {},
	components: {
		MyRaportCard
	},
	data() {
		return {
			statuses: [],
			loading: true,
			dataloaded: false
		};
	},
	computed: {
		showcards(){
			return this.$route.name === 'my_reports_label'
		}
	},
	watch: {
		$route (to, from){
			if (this.dataloaded) {
				this.$store.state.active_loader = false;
			}
		},
	},
  	mounted() {
		this.getUserReportsfromCall();
		this.clearStoarage();
  	},
  	methods: {
		clearStoarage() {
			localStorage.color = "";
			localStorage.reports = "";
		},
		getUserReportsfromCall() {
			reports
			.getUserReports({
				userID: localStorage.getItem("user_id")
			})
			.then(response => {
				this.statuses = response.data.status;
				this.$store.state.active_loader = false;
				this.dataloaded = true
			})
			.catch(error => {
				// console.log("There was an error:", error);
				this.$store.state.active_loader = false;
			});
		}
  	}
};
</script>


<style scope lang="scss" src="./MyRaports.scss">
</style>


